import { useDisclosure } from "@heroui/react";
import { toast } from "react-toastify";
import { useAppSelector } from "@/hooks/useAppSelector.ts";
import { api } from "@/api";
import {
  getIdFromOfficeHandbook,
  getIdFromCategoryHandbook,
} from "@/utils/getIdFromHandbook.ts";
import { InputField } from "../../forms/formBuilder";
import { FormModalBuilder, ModalError } from "../formModalBuilder";
import { useState } from "react";
import useErrorHandling from "@/hooks/useErrorHandling";

interface CreateUserToLandlordTicketForm {
  subject: string;
  category: number;
  office: number;
  priority: "low" | "medium" | "high" | "urgent";
  visible_to_company: boolean;
}

const createUserToLandlordTicketFields: InputField[] = [
  {
    label: "Тема обращения",
    name: "subject",
    placeholder: "Введите тему обращения",
    type: "text",
  },
  {
    label: "Категория",
    name: "category",
    placeholder: "",
    type: "user-to-landlord-category",
  },
  {
    label: "Офис",
    name: "office",
    placeholder: "",
    type: "office",
  },
  {
    label: "Приоритет",
    name: "priority",
    placeholder: "",
    type: "priority",
  },
  {
    label: "Доступно компании",
    name: "visible_to_company",
    placeholder: "",
    type: "boolean",
  },
];

export function CreateUserToLandlordTicketModal({
  disclosure,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
}) {
  const { isOpen, onOpenChange } = disclosure;
  const user = useAppSelector((state) => state.user.currentUser.id);

  const [modalErrors, setModalErrors] = useState<ModalError[]>([]);
  const handleError = useErrorHandling();

  const onSubmit = (data: CreateUserToLandlordTicketForm) => {
    return new Promise<boolean>((resolve) => {
      Promise.all([
        getIdFromOfficeHandbook(String(data.office)),
        getIdFromCategoryHandbook(String(data.category)),
      ])
        .then(([office, category]) => {
          return api.tickets.create({
            subject: data.subject,
            type: "user_to_landlord",
            category: Number(category),
            office_id: Number(office),
            user_id: user!,
            visible_to_company: data.visible_to_company,
            priority: data.priority,
          });
        })
        .then(() => {
          disclosure.onClose();
          toast.success("Тикет успешно создан");
          resolve(true);
        })
        .catch((err) => {
          console.log(err);
          const { errorMessage, parsedErrors } = handleError(err);
          setModalErrors(parsedErrors || []);
          toast.error(errorMessage);
          resolve(false);
        });
    });
  };

  return (
    <FormModalBuilder
      modalErrors={modalErrors}
      title="Создание тикета к арендодателю"
      fields={createUserToLandlordTicketFields}
      isOpen={isOpen}
      isSensitiveData={false}
      onOpenChange={onOpenChange}
      onSubmit={onSubmit}
    />
  );
}
